var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rate-details" }, [
    _c(
      "div",
      { ref: "header", staticClass: "rate-details-header" },
      [
        _c("header-close", { attrs: { deactivate: _vm.deactivate } }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.room.title + " - " + _vm.rate.title)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "rate-details-scroll",
        style: [{ height: _vm.scrollHeight + "px" }],
      },
      [
        _c("div", { staticClass: "rate-img" }, [
          _c(
            "picture",
            {
              directives: [
                {
                  name: "lazyload",
                  rawName: "v-lazyload",
                  value: {
                    src: _vm.rateImg.src,
                    set: [
                      { width: "640", height: "307", breakpoint: "xs" },
                      { width: "800", height: "412", breakpoint: "lg" },
                    ],
                    fit: "crop",
                    align: "center",
                  },
                  expression:
                    "{\n            src: rateImg.src,\n            set: [\n              { width: '640', height: '307', breakpoint: 'xs' },\n              { width: '800', height: '412', breakpoint: 'lg' }\n            ],\n            fit: 'crop',\n            align: 'center'\n          }",
                },
              ],
              staticClass: "image-wrapper",
            },
            [
              _c("img", {
                staticClass: "image",
                attrs: {
                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                  alt: _vm.rateImg.alt,
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rate-details-info" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.rate.title || "Our best rate")),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "description short",
            domProps: { innerHTML: _vm._s(_vm.rate.shortDescription) },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.rate.longDescription) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "price-breakdown-main" },
          [
            _c("div", { staticClass: "section-label" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("booking.priceBreakdown")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "overview-item" }, [
              _c("div", { staticClass: "item-label bold-item" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.rate.title || "Our best rate") +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value" }, [
                _c("div", [_vm._v(_vm._s(_vm.avgPrice))]),
                _vm._v(" "),
                _c("div", { staticClass: "section-label sub no-margin" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.tc("booking.avgPerNight")) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "overview-item nightly-rates" }, [
              _c("div", { staticClass: "item-label bold-item" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.rate.nightlyRates.length) +
                    " " +
                    _vm._s(
                      _vm.rate.nightlyRates.length > 1
                        ? _vm.tc("noums.nightPlural")
                        : _vm.tc("noums.nightSingular")
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-value bold-item" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.getDisplayPrice({ price: _vm.totalPerNight })) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("overview-nightly-rates", {
              attrs: { "nightly-rates": _vm.rate.nightlyRates },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "price-breakdown-taxes" }, [
          _c("div", { staticClass: "section-label" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.tc("booking.taxesAndFees")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "overview-item" }, [
            _c("div", { staticClass: "item-label bold-item" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.tc("booking.total")) +
                  " " +
                  _vm._s(_vm.tc("booking.taxesAndFees")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item-value bold-item" }, [
              _vm._v("\n          " + _vm._s(_vm.totalTaxes) + "\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "overview-items-wrapper" },
            _vm._l(_vm.rate.taxesFees, function (item, i) {
              return _c(
                "div",
                {
                  key: item.code + i,
                  staticClass: "overview-item",
                  class: [
                    { "small-margin": i < _vm.rate.taxesFees.length - 1 },
                    { "no-margin": i === _vm.rate.taxesFees.length - 1 },
                  ],
                },
                [
                  _c("div", { staticClass: "item-label section-label" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(item.description) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-value" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getDisplayPrice({ price: item.price })) +
                        "\n          "
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.rate.restrictionPolicy
          ? _c("div", { staticClass: "restriction-policy" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.tc("booking.restrictionPolicy")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "section-body",
                domProps: { innerHTML: _vm._s(_vm.rate.restrictionPolicy) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "terms-and-conditions" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.termsAndConditions")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "section-body",
            domProps: { innerHTML: _vm._s(_vm.rate.termsAndConditions) },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "footer", staticClass: "rate-details-footer rate-cta-wrapper" },
      [
        _c("div", { staticClass: "rate-price" }, [
          _c("div", { staticClass: "price" }, [
            _c("strong", [_vm._v(_vm._s(_vm.tc("booking.total")))]),
            _vm._v(" "),
            _c("span", [_vm._v(" " + _vm._s(_vm.totalDisplay))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "rate-cta",
            class: [
              { "is-selecting": _vm.isLoading },
              { selected: _vm.isSelected },
            ],
          },
          [
            _c(
              "button",
              {
                attrs: { disabled: _vm.isDisabled },
                on: {
                  click: _vm.doCartAction,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.doCartAction($event)
                  },
                },
              },
              [
                !_vm.isLoading
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            !_vm.isSelected
                              ? _vm.tc("booking.bookThisRate")
                              : _vm.tc("booking.keepThisRate")
                          ) +
                          "\n          "
                      ),
                    ])
                  : _c("loading-dots"),
              ],
              1
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }